// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s0ZZ","type":"styles_type__O2Pmk","choices":"styles_choices__1_Vk7"};